module.exports = __webpack_public_path__ + "img/prj05.37b239b9.png";